import { EventTypeInfo } from './event_type_info'
import { InfoBanner } from './info_banner'
import { TabContainer } from './styles'
import {
  InviteesWidget,
  LocationsWidget,
  UtmParamsWidget,
  HostsWidget,
  PaymentWidget,
  QuestionsWidget,
  TimelineWidget,
  MeetingPackageWidget
} from './widgets'


export const DetailsTab = ({ selectedEvent }) => (
  <TabContainer>
    <InfoBanner event={selectedEvent} />
    <InviteesWidget event={selectedEvent} />
    <QuestionsWidget event={selectedEvent} />
    <LocationsWidget event={selectedEvent} />
    <UtmParamsWidget event={selectedEvent} />
    <HostsWidget event={selectedEvent} />
    <PaymentWidget event={selectedEvent} />
    <TimelineWidget event={selectedEvent} />
    <MeetingPackageWidget event={selectedEvent} />
    <EventTypeInfo event={selectedEvent} />
  </TabContainer>
)
